import { IonButton } from '@ionic/react';
import { useIonRouter } from '@ionic/react';
import revLogo from '../../assets/REV_logo.svg';
import revLogoWhite from '../../assets/REV_logo_white.svg';
import { Link } from 'react-router-dom';

export const HomeContent: React.FC = () => {
  const router = useIonRouter();
  const accountFormUrl = import.meta.env.VITE_ACCOUNT_FORM_URL;
  const isNonProd = import.meta.env.VITE_ENV !== 'prod';

  const handleSignIn = () => {
    router.push('/sign-in');
  };

  const handleContactSales = () => {
    if (accountFormUrl) {
      window.open(accountFormUrl, '_blank');
    }
  };

  const handleFreeShop = () => {
    window.open('https://www.rev-leasing.com/free-mystery-shop', '_blank');
  };

  const handleLearnMore = () => {
    window.open('https://www.rev-leasing.com', '_blank');
  };

  return (
    <>
      <div className="flex items-center px-4 py-4">
        <Link to="/" className="flex items-center">
          <img src={revLogo} alt="REV Logo" className="h-8 w-auto dark:hidden" />
          <img src={revLogo} alt="REV Logo" className="h-8 w-auto hidden dark:block" />
        </Link>
      </div>
      <div className="flex flex-col items-center justify-center h-full px-6 text-center">
        {/* Main Headline */}
        <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold mb-6 max-w-5xl">
          Turn Every Leasing Professional Into a{' '}
          <span className="text-[#D16972]">Top Performer</span>
        </h1>

        {/* Subtitle */}
        <div className="text-xl md:text-2xl mb-4 max-w-3xl">
          <div className="font-semibold mb-2">
            Revenue-focused training for multifamily leasing professionals.
            <br/>Drive real results across your portfolio.
          </div>
        </div>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row">
          <IonButton
            onClick={handleSignIn}
            size="large"
            className="mx-4 my-3"
            style={{
              '--background': '#D16972',
              '--background-hover': '#B85862',
              '--border-radius': '8px',
            }}
          >
            Sign In
          </IonButton>

          <IonButton
            onClick={handleContactSales}
            fill="outline"
            size="large"
            className="mx-4 my-3"
            style={{
              '--border-color': '#D16972',
              '--color': '#D16972',
              '--border-radius': '8px',
            }}
          >
            Contact Sales
          </IonButton>
        </div>

        {/* Free Mystery Shop Link */}
        <div className="mt-6 p-4 bg-white rounded-lg border border-gray-200">
          <span className="text-gray-700">Want to test your team first? </span>
          <button
            onClick={handleFreeShop}
            className="text-[#D16972] font-semibold hover:underline"
          >
            Try our free AI mystery shop →
          </button>
        </div>

        {/* Learn More Link */}
        <div className="mt-24">
          <button
            onClick={handleLearnMore}
            className="text-[#D16972] italic font-semibold hover:underline text-lg"
          >
            Learn more...
          </button>
        </div>
      </div>

      {/* Version Number - Bottom Right Corner */}
      <div className="fixed bottom-2 left-2 text-[8px] text-gray-400">
        {import.meta.env.VITE_VERSION}
      </div>
    </>
  );
};
